(function() {
  define('tlhComponentsEditableText',['angular'], function() {
    'use strict';
    return angular.module('tlhComponentsEditableText', []).component('tlhEditableText', {
      require: {
        ngModel: 'ngModel'
      },
      bindings: {
        allowReturn: '<'
      },
      controller: [
        '$element', '$scope', function($element, $scope) {
          var handleInput, handleKeydown, handlePaste, readInput, vm;
          vm = this;
          vm.$onInit = function() {
            vm.ngModel.$render = function() {
              return $element.html(vm.ngModel.$viewValue || '');
            };
            $element.addClass('tlh-editable-content');
            return $element.attr('contenteditable', true);
          };
          readInput = function() {
            return vm.ngModel.$setViewValue($element.html());
          };
          handleInput = function() {
            if (!$element.text()) {
              $element.html('');
            }
            return $scope.$apply(readInput);
          };
          handleKeydown = function(e) {
            switch (e.which) {
              case 13:
                if (!$scope.allowReturn) {
                  return e.preventDefault();
                }
            }
          };
          handlePaste = function(e) {
            var bufferText;
            e.preventDefault();
            bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
            return document.execCommand("insertText", false, bufferText.replace(/(?:\r\n|\r|\n)/g, ' '));
          };
          $element.on('input', handleInput);
          $element.on('keydown', handleKeydown);
          $element.on('paste', handlePaste);
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=editableText.js.map
;
